import { isSameDay } from 'date-fns'

class DateRange {
  constructor(label, startDate, endDate) {
    this.label = label
    this.startDate = startDate
    this.endDate = endDate

    Object.freeze(this)
  }

  range() {
    return {
      ...this,
      range: {
        startDate: this.startDate,
        endDate: this.endDate,
      },
    }
  }

  isSelected(range) {
    return (
      isSameDay(range.startDate, this.startDate) &&
      isSameDay(range.endDate, this.endDate)
    )
  }
}

export default DateRange
